import { currentUser } from "modules/utilities/utility";
import api from "../../../../api/index"
import secureLocalStorage from "react-secure-storage";


export function todayEngagement(params) {
    return api.get('v2/weekly-schedule-engagements', {
        params: {
            rep_id: secureLocalStorage.getItem('id'),
            start_date: params.start_date,
            end_date: params.end_date,
            tag_filter: params.tag_filter || undefined,
            from_crm: params.from_crm || undefined,
            page: params.page || 1,
            limit: params.limit || 10,
        }
    });
}

export function tempLeadEng(params){
    return api.get('v2/weekly-schedule-engagements', {
        params: {
            temporary_rep_id: secureLocalStorage.getItem('id'),
            start_date: params.start_date,
            end_date: params.end_date,
            page: params.page || 1,
            limit: params.limit || 10,
        }
    });
}

export function tempEngagement(params) {
    return api.get('v2/weekly-schedule-engagements', {
        params: {
            temporary_rep_id: secureLocalStorage.getItem('id'),
            tag_filter: params.tag_filter || undefined,
            start_date: params.start_date,
            end_date: params.end_date,
            page: params.page || 1,
            limit: params.limit || 10,
        }
    });
}

// Slot view API (server-side filtered + paginated)
export function slotViewEngagement(params) {
    return api.get('v2/weekly-schedule-engagements', {
        params: {
            rep_id: params.rep_id,
            include_temp: 'true',
            start_date: params.start_date,
            end_date: params.end_date,
            tag_filter: 'SLOT_BOOKING_TOTAL',
            page: params.page,
            limit: params.limit,
        }
    });
}

// Lead agent tab APIs using new weekly-schedule-engagements endpoint
export function leadSlotBookingEng(params) {
    return api.get('v2/weekly-schedule-engagements', {
        params: {
            rep_id: params.rep_id,
            include_temp: 'true',
            start_date: params.start_date,
            end_date: params.end_date,
            exclude_request_type: 'lead_cold_slot',
            exclude_reattempt: 'true',
            page: params.page,
            limit: params.limit,
        }
    });
}

export function leadColdCallEng(params) {
    return api.get('v2/weekly-schedule-engagements', {
        params: {
            rep_id: params.rep_id,
            include_temp: 'true',
            start_date: params.start_date,
            end_date: params.end_date,
            request_type: 'lead_cold_slot',
            page: params.page,
            limit: params.limit,
        }
    });
}

export function leadReattemptEng(params) {
    return api.get('v2/weekly-schedule-engagements', {
        params: {
            rep_id: params.rep_id,
            include_temp: 'true',
            start_date: params.start_date,
            end_date: params.end_date,
            reattempt: 'true',
            page: params.page,
            limit: params.limit,
        }
    });
}



